import * as React from "react";
import { connect } from "react-redux";
import * as d from "../../reducers/domainReducer";
import { logUI } from "../../api/andyliticsApi";
import { getURLPath } from '../../helpers/Tools';
import { getFirstName } from "../../helpers/formatting";
import * as types from "../../constants/actionTypes";
import Spinner from "../common/spinner";
import { UncontrolledTooltip } from 'reactstrap';
import StaticHtmlContent from "../common/staticHtmlContent";
import * as queryString from 'query-string';

class ScheduleVaccineRedirect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            isGeoAddressFetch: false
        };
    }

    componentDidMount() {
        const { isLoggedIn, userName, getUserAddress, latitude, longitude, curPosLatitude, curPosLongitude, cityAddress, stateAddress } = this.props;

        //debugger;
        var newPath = "/Schedule Vaccine Landing" ;
        var newUrl = window.location.origin + newPath + window.location.search; 
        //debugger;
        if (window.self !== window.top) {
            window.top.location = newUrl;
        }
        else {
            this.props.history.push({ pathname: newPath, searchParms: window.location.search });
        }
        return;

    }

    componentDidUpdate(prevProps) {
    }


    render() {
        return <div></div>
    }

}
const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getUserAddress: (userName) => {
            dispatch({
                type: types.GET_USER_ADDRESS_START, userName: userName
            });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleVaccineRedirect);